/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DescriptionValue/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DescriptionValue({
  children,
  viewPath = "/DesignSystem/DescriptionValue",
  alignItems,
  alignSelf,
  justifyContent,
  overflowX
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DescriptionValue.Vertical"
  data-view-path={viewPath}
 style={{'--ai-1-ZoRH1a': alignItems,'--as-2-ZoRH1a': alignSelf,'--jc-3-ZoRH1a': justifyContent,'--ox-4-ZoRH1a': overflowX}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}